import { render, staticRenderFns } from "./adjektiv-komparation.vue?vue&type=template&id=d9feebea&scoped=true"
import script from "./adjektiv-komparation.vue?vue&type=script&lang=js"
export * from "./adjektiv-komparation.vue?vue&type=script&lang=js"
import style0 from "./adjektiv-komparation.vue?vue&type=style&index=0&id=d9feebea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9feebea",
  null
  
)

export default component.exports